<script setup>

import {onMounted, ref} from "vue";
import { useNotificationStore } from '@/stores/NotificationStore.js'
const notificationStore = useNotificationStore()

const emit = defineEmits(['reload'])

const templates = ref([])

const loadTemplates = async () => {
    const res = await axios.get(route('api.task-list-templates.index'))
    templates.value = res.data.templates
}

const accept = async (template) => {
    const res = await axios.post(route('api.task-list-templates.accept', template.id))
    if (res.data.success) {
        emit('reload')
        notificationStore.addNotification({
            type: 'success',
            title: 'Task list created',
            message: template.name + ' has been added to your task lists',
            dismissAfter: 5000,
        })
        await loadTemplates()
    } else {
        notificationStore.addNotification({
            type: 'error',
            title: 'Something went wrong',
            message: res.data.message,
            dismissAfter: 5000,
        })
    }
}

const decline = async (template) => {
    const res = await axios.post(route('api.task-list-templates.decline', template.id))
    if (res.data.success) {
        emit('reload')
        await loadTemplates()
    } else {
        notificationStore.addNotification({
            type: 'error',
            title: 'Something went wrong',
            message: res.data.message,
            dismissAfter: 5000,
        })
    }
}

onMounted(() => {
    loadTemplates();
});

</script>
<template>
    <div
        v-if="templates.length > 0"
        class="mb-8"
    >
        <list-basic>
            <list-basic-item
                v-for="(template, i) in templates"
                :key="i"
            >
                <template #title>
                    {{ template.name }}
                </template>
                <span class="text-xs text-gray-400">
                    {{ template.tasks.length }} tasks
                </span>
                <template #actions>
                    <div class="flex flex-col items-stretch space-y-1">
                        <button-primary
                            size="sm"
                            class="justify-center"
                            @click="accept(template)"
                        >
                            Accept
                        </button-primary>
                        <button-danger
                            size="sm"
                            class="justify-center"
                            @click="decline(template)"
                        >
                            Decline
                        </button-danger>
                    </div>
                </template>
            </list-basic-item>
        </list-basic>
    </div>
</template>
